"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.function.name.js");
var _get_year = _interopRequireDefault(require("date-fns/get_year"));
var _get_month = _interopRequireDefault(require("date-fns/get_month"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _section = require("@nucleo/section");
var _product = require("@nucleo/product");
function cov_1vlgqypoqo() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/calendar/lib/model.js";
  var hash = "a92106a8c0879fd3c8b6d1eb9c850be9a827cf5a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/calendar/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 23
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 9,
          column: 32
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 79
        }
      },
      "3": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 17
        }
      },
      "4": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 144,
          column: 1
        }
      },
      "5": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "6": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 76
        }
      },
      "7": {
        start: {
          line: 18,
          column: 55
        },
        end: {
          line: 18,
          column: 75
        }
      },
      "8": {
        start: {
          line: 20,
          column: 33
        },
        end: {
          line: 20,
          column: 69
        }
      },
      "9": {
        start: {
          line: 20,
          column: 55
        },
        end: {
          line: 20,
          column: 68
        }
      },
      "10": {
        start: {
          line: 21,
          column: 35
        },
        end: {
          line: 21,
          column: 72
        }
      },
      "11": {
        start: {
          line: 21,
          column: 57
        },
        end: {
          line: 21,
          column: 71
        }
      },
      "12": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 22,
          column: 23
        }
      },
      "13": {
        start: {
          line: 23,
          column: 28
        },
        end: {
          line: 23,
          column: 49
        }
      },
      "14": {
        start: {
          line: 25,
          column: 27
        },
        end: {
          line: 25,
          column: 77
        }
      },
      "15": {
        start: {
          line: 25,
          column: 71
        },
        end: {
          line: 25,
          column: 76
        }
      },
      "16": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 41,
          column: 9
        }
      },
      "17": {
        start: {
          line: 29,
          column: 28
        },
        end: {
          line: 29,
          column: 49
        }
      },
      "18": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 34,
          column: 9
        }
      },
      "19": {
        start: {
          line: 33,
          column: 10
        },
        end: {
          line: 33,
          column: 62
        }
      },
      "20": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 38,
          column: 9
        }
      },
      "21": {
        start: {
          line: 37,
          column: 10
        },
        end: {
          line: 37,
          column: 57
        }
      },
      "22": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 49
        }
      },
      "23": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 20
        }
      },
      "24": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 46,
          column: 8
        }
      },
      "25": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 14
        }
      },
      "26": {
        start: {
          line: 52,
          column: 27
        },
        end: {
          line: 52,
          column: 29
        }
      },
      "27": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "28": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 16
        }
      },
      "29": {
        start: {
          line: 57,
          column: 62
        },
        end: {
          line: 57,
          column: 66
        }
      },
      "30": {
        start: {
          line: 58,
          column: 29
        },
        end: {
          line: 58,
          column: 35
        }
      },
      "31": {
        start: {
          line: 60,
          column: 18
        },
        end: {
          line: 60,
          column: 62
        }
      },
      "32": {
        start: {
          line: 61,
          column: 18
        },
        end: {
          line: 61,
          column: 49
        }
      },
      "33": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "34": {
        start: {
          line: 64,
          column: 24
        },
        end: {
          line: 64,
          column: 64
        }
      },
      "35": {
        start: {
          line: 65,
          column: 22
        },
        end: {
          line: 65,
          column: 69
        }
      },
      "36": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 42
        }
      },
      "37": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 30
        }
      },
      "38": {
        start: {
          line: 73,
          column: 25
        },
        end: {
          line: 73,
          column: 27
        }
      },
      "39": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "40": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 72
        }
      },
      "41": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 26
        }
      },
      "42": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 78
        }
      },
      "43": {
        start: {
          line: 86,
          column: 22
        },
        end: {
          line: 86,
          column: 62
        }
      },
      "44": {
        start: {
          line: 87,
          column: 20
        },
        end: {
          line: 87,
          column: 45
        }
      },
      "45": {
        start: {
          line: 88,
          column: 20
        },
        end: {
          line: 90,
          column: 5
        }
      },
      "46": {
        start: {
          line: 89,
          column: 12
        },
        end: {
          line: 89,
          column: 72
        }
      },
      "47": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "48": {
        start: {
          line: 93,
          column: 64
        },
        end: {
          line: 93,
          column: 68
        }
      },
      "49": {
        start: {
          line: 94,
          column: 31
        },
        end: {
          line: 94,
          column: 37
        }
      },
      "50": {
        start: {
          line: 95,
          column: 25
        },
        end: {
          line: 97,
          column: 41
        }
      },
      "51": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 105,
          column: 8
        }
      },
      "52": {
        start: {
          line: 102,
          column: 27
        },
        end: {
          line: 102,
          column: 95
        }
      },
      "53": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 65
        }
      },
      "54": {
        start: {
          line: 109,
          column: 30
        },
        end: {
          line: 111,
          column: 5
        }
      },
      "55": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 118,
          column: 7
        }
      },
      "56": {
        start: {
          line: 116,
          column: 15
        },
        end: {
          line: 116,
          column: 47
        }
      },
      "57": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 29
        }
      },
      "58": {
        start: {
          line: 122,
          column: 23
        },
        end: {
          line: 122,
          column: 46
        }
      },
      "59": {
        start: {
          line: 123,
          column: 25
        },
        end: {
          line: 123,
          column: 40
        }
      },
      "60": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 73
        }
      },
      "61": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 83
        }
      },
      "62": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 98
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 23
          },
          end: {
            line: 8,
            column: 24
          }
        },
        loc: {
          start: {
            line: 8,
            column: 31
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 15,
            column: 14
          }
        },
        loc: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 18,
            column: 48
          }
        },
        loc: {
          start: {
            line: 18,
            column: 55
          },
          end: {
            line: 18,
            column: 75
          }
        },
        line: 18
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 47
          },
          end: {
            line: 20,
            column: 48
          }
        },
        loc: {
          start: {
            line: 20,
            column: 55
          },
          end: {
            line: 20,
            column: 68
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 21,
            column: 49
          },
          end: {
            line: 21,
            column: 50
          }
        },
        loc: {
          start: {
            line: 21,
            column: 57
          },
          end: {
            line: 21,
            column: 71
          }
        },
        line: 21
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 25,
            column: 53
          },
          end: {
            line: 25,
            column: 54
          }
        },
        loc: {
          start: {
            line: 25,
            column: 71
          },
          end: {
            line: 25,
            column: 76
          }
        },
        line: 25
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 27,
            column: 43
          },
          end: {
            line: 27,
            column: 44
          }
        },
        loc: {
          start: {
            line: 27,
            column: 61
          },
          end: {
            line: 41,
            column: 7
          }
        },
        line: 27
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 13
          }
        },
        loc: {
          start: {
            line: 51,
            column: 43
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 51
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 24
          }
        },
        loc: {
          start: {
            line: 72,
            column: 41
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 72
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 80,
            column: 17
          },
          end: {
            line: 80,
            column: 18
          }
        },
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 78
          }
        },
        line: 81
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        },
        loc: {
          start: {
            line: 85,
            column: 80
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 85
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        },
        loc: {
          start: {
            line: 89,
            column: 12
          },
          end: {
            line: 89,
            column: 72
          }
        },
        line: 89
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 102,
            column: 22
          },
          end: {
            line: 102,
            column: 23
          }
        },
        loc: {
          start: {
            line: 102,
            column: 27
          },
          end: {
            line: 102,
            column: 95
          }
        },
        line: 102
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        },
        loc: {
          start: {
            line: 116,
            column: 15
          },
          end: {
            line: 116,
            column: 47
          }
        },
        line: 116
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 122,
            column: 12
          }
        },
        loc: {
          start: {
            line: 122,
            column: 23
          },
          end: {
            line: 122,
            column: 46
          }
        },
        line: 122
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 123,
            column: 13
          },
          end: {
            line: 123,
            column: 14
          }
        },
        loc: {
          start: {
            line: 123,
            column: 25
          },
          end: {
            line: 123,
            column: 40
          }
        },
        line: 123
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 130,
            column: 19
          },
          end: {
            line: 130,
            column: 20
          }
        },
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 73
          }
        },
        line: 131
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 138,
            column: 27
          },
          end: {
            line: 138,
            column: 28
          }
        },
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 83
          }
        },
        line: 139
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 142,
            column: 36
          },
          end: {
            line: 142,
            column: 37
          }
        },
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 143,
            column: 98
          }
        },
        line: 143
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 16,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 16,
            column: 26
          }
        }, {
          start: {
            line: 16,
            column: 30
          },
          end: {
            line: 16,
            column: 61
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 34,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 34,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 18
          },
          end: {
            line: 60,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 33
          },
          end: {
            line: 60,
            column: 48
          }
        }, {
          start: {
            line: 60,
            column: 51
          },
          end: {
            line: 60,
            column: 62
          }
        }],
        line: 60
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 18
          },
          end: {
            line: 61,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 33
          },
          end: {
            line: 61,
            column: 38
          }
        }, {
          start: {
            line: 61,
            column: 41
          },
          end: {
            line: 61,
            column: 49
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 63
      },
      "8": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 13
          }
        }, {
          start: {
            line: 63,
            column: 17
          },
          end: {
            line: 63,
            column: 37
          }
        }],
        line: 63
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 15
          }
        }, {
          start: {
            line: 81,
            column: 19
          },
          end: {
            line: 81,
            column: 45
          }
        }, {
          start: {
            line: 81,
            column: 49
          },
          end: {
            line: 81,
            column: 78
          }
        }],
        line: 81
      },
      "11": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }, {
          start: {
            line: 106,
            column: 11
          },
          end: {
            line: 108,
            column: 5
          }
        }],
        line: 92
      },
      "12": {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 12
          }
        }, {
          start: {
            line: 92,
            column: 17
          },
          end: {
            line: 92,
            column: 33
          }
        }, {
          start: {
            line: 92,
            column: 37
          },
          end: {
            line: 92,
            column: 57
          }
        }],
        line: 92
      },
      "13": {
        loc: {
          start: {
            line: 95,
            column: 25
          },
          end: {
            line: 97,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 96,
            column: 45
          }
        }, {
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 97,
            column: 41
          }
        }],
        line: 95
      },
      "14": {
        loc: {
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 103,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 102,
            column: 96
          }
        }, {
          start: {
            line: 103,
            column: 12
          },
          end: {
            line: 103,
            column: 20
          }
        }],
        line: 101
      },
      "15": {
        loc: {
          start: {
            line: 116,
            column: 15
          },
          end: {
            line: 116,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 116,
            column: 42
          }
        }, {
          start: {
            line: 116,
            column: 45
          },
          end: {
            line: 116,
            column: 47
          }
        }],
        line: 116
      },
      "16": {
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 12
          }
        }, {
          start: {
            line: 131,
            column: 16
          },
          end: {
            line: 131,
            column: 39
          }
        }, {
          start: {
            line: 131,
            column: 43
          },
          end: {
            line: 131,
            column: 73
          }
        }],
        line: 131
      },
      "17": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 143,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 143,
            column: 12
          },
          end: {
            line: 143,
            column: 19
          }
        }, {
          start: {
            line: 143,
            column: 22
          },
          end: {
            line: 143,
            column: 98
          }
        }],
        line: 143
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a92106a8c0879fd3c8b6d1eb9c850be9a827cf5a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vlgqypoqo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vlgqypoqo();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_1vlgqypoqo().s[0]++;
var forceDateToUTC = function forceDateToUTC(date) {
  cov_1vlgqypoqo().f[0]++;
  var newDate = (cov_1vlgqypoqo().s[1]++, new Date(date));
  cov_1vlgqypoqo().s[2]++;
  newDate.setTime(newDate.getTime() + newDate.getTimezoneOffset() * 60 * 1000);
  cov_1vlgqypoqo().s[3]++;
  return newDate;
};
var CalendarModel = (cov_1vlgqypoqo().s[4]++, {
  getMonths: function getMonths(data) {
    cov_1vlgqypoqo().f[1]++;
    cov_1vlgqypoqo().s[5]++;
    if ((cov_1vlgqypoqo().b[1][0]++, data.calendarRange) && (cov_1vlgqypoqo().b[1][1]++, data.calendarRange.length === 2)) {
      cov_1vlgqypoqo().b[0][0]++;
      // get the date range to get later the year/month from to
      var dateRange = (cov_1vlgqypoqo().s[6]++, data.calendarRange.map(function (date) {
        cov_1vlgqypoqo().f[2]++;
        cov_1vlgqypoqo().s[7]++;
        return forceDateToUTC(date);
      }));
      // get the date range to compute the month definition
      var _ref = (cov_1vlgqypoqo().s[8]++, dateRange.map(function (date) {
          cov_1vlgqypoqo().f[3]++;
          cov_1vlgqypoqo().s[9]++;
          return (0, _get_year.default)(date);
        })),
        _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        yearFrom = _ref2[0],
        yearTo = _ref2[1];
      var _ref3 = (cov_1vlgqypoqo().s[10]++, dateRange.map(function (date) {
          cov_1vlgqypoqo().f[4]++;
          cov_1vlgqypoqo().s[11]++;
          return (0, _get_month.default)(date);
        })),
        _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        monthFrom = _ref4[0],
        monthTo = _ref4[1];
      var months = (cov_1vlgqypoqo().s[12]++, {});
      var numberOfYears = (cov_1vlgqypoqo().s[13]++, yearTo - yearFrom + 1);
      // generate the whole list of months in a year array from 0 to 11
      var completeYear = (cov_1vlgqypoqo().s[14]++, (0, _from.default)(new Array(12), function (value, index) {
        cov_1vlgqypoqo().f[5]++;
        cov_1vlgqypoqo().s[15]++;
        return index;
      }));
      // generate the year map looping on the years
      cov_1vlgqypoqo().s[16]++;
      (0, _from.default)(new Array(numberOfYears), function (value, index) {
        cov_1vlgqypoqo().f[6]++;
        // clone the array of months
        var curYearMonths = (cov_1vlgqypoqo().s[17]++, completeYear.slice(0));
        // if it is the last year remove the last months
        // If there is only one year, it is important to remove first the last months and then the first months
        cov_1vlgqypoqo().s[18]++;
        if (index === numberOfYears - 1) {
          cov_1vlgqypoqo().b[2][0]++;
          cov_1vlgqypoqo().s[19]++;
          curYearMonths = curYearMonths.slice(0, monthTo + 1);
        } else {
          cov_1vlgqypoqo().b[2][1]++;
        }
        // if it is the first year, remove the months before the first date
        cov_1vlgqypoqo().s[20]++;
        if (index === 0) {
          cov_1vlgqypoqo().b[3][0]++;
          cov_1vlgqypoqo().s[21]++;
          curYearMonths = curYearMonths.slice(monthFrom);
        } else {
          cov_1vlgqypoqo().b[3][1]++;
        }
        cov_1vlgqypoqo().s[22]++;
        months[yearFrom + index] = curYearMonths;
        cov_1vlgqypoqo().s[23]++;
        return null;
      });
      cov_1vlgqypoqo().s[24]++;
      return {
        firstDate: dateRange[0],
        lastDate: dateRange[1],
        months: months
      };
    } else {
      cov_1vlgqypoqo().b[0][1]++;
    }
    cov_1vlgqypoqo().s[25]++;
    return {};
  },
  getMonth: function getMonth(data, year, month, config) {
    cov_1vlgqypoqo().f[7]++;
    var sectionByMonth = (cov_1vlgqypoqo().s[26]++, {});
    cov_1vlgqypoqo().s[27]++;
    if (!data) {
      cov_1vlgqypoqo().b[4][0]++;
      cov_1vlgqypoqo().s[28]++;
      return {};
    } else {
      cov_1vlgqypoqo().b[4][1]++;
    }
    var _ref5 = (cov_1vlgqypoqo().s[29]++, data),
      tours = _ref5.tours,
      products = _ref5.products,
      occurrences = _ref5.occurrences,
      tourOccurrences = _ref5.tourOccurrences;
    var _ref6 = (cov_1vlgqypoqo().s[30]++, config),
      withTourOnly = _ref6.withTourOnly;
    var occur = (cov_1vlgqypoqo().s[31]++, withTourOnly ? (cov_1vlgqypoqo().b[5][0]++, tourOccurrences) : (cov_1vlgqypoqo().b[5][1]++, occurrences));
    var items = (cov_1vlgqypoqo().s[32]++, withTourOnly ? (cov_1vlgqypoqo().b[6][0]++, tours) : (cov_1vlgqypoqo().b[6][1]++, products));
    cov_1vlgqypoqo().s[33]++;
    if ((cov_1vlgqypoqo().b[8][0]++, occur) && (cov_1vlgqypoqo().b[8][1]++, (0, _isArray.default)(items))) {
      cov_1vlgqypoqo().b[7][0]++;
      var monthName = (cov_1vlgqypoqo().s[34]++, (0, _format.default)(new Date(year, month), 'YYYY-MM'));
      var section = (cov_1vlgqypoqo().s[35]++, _section.SectionModel.getFromMonth(occur, items, config));
      cov_1vlgqypoqo().s[36]++;
      sectionByMonth[monthName] = section;
    } else {
      cov_1vlgqypoqo().b[7][1]++;
    }
    cov_1vlgqypoqo().s[37]++;
    return {
      sectionByMonth: sectionByMonth
    };
  },
  getOccurrencesMonth: function getOccurrencesMonth(data, config) {
    cov_1vlgqypoqo().f[8]++;
    var sectionByMonth = (cov_1vlgqypoqo().s[38]++, {});
    cov_1vlgqypoqo().s[39]++;
    if (data) {
      cov_1vlgqypoqo().b[9][0]++;
      cov_1vlgqypoqo().s[40]++;
      sectionByMonth = _section.SectionModel.getOccurrencesByMonth(data, config);
    } else {
      cov_1vlgqypoqo().b[9][1]++;
    }
    cov_1vlgqypoqo().s[41]++;
    return sectionByMonth;
  },
  getFirstOccur: function getFirstOccur(occurrences) {
    cov_1vlgqypoqo().f[9]++;
    cov_1vlgqypoqo().s[42]++;
    return (cov_1vlgqypoqo().b[10][0]++, occurrences) && (cov_1vlgqypoqo().b[10][1]++, (0, _values.default)(occurrences)) && (cov_1vlgqypoqo().b[10][2]++, (0, _values.default)(occurrences)[0]);
  },
  // when loading a day in a calendar, we have to provide the information that it is loading
  // Or when the data are loaded, the new data should be computed
  getSectionByMonthForDayChange: function getSectionByMonthForDayChange(sectionByMonth, year, month, day, data, config) {
    var _this = this;
    cov_1vlgqypoqo().f[10]++;
    var monthName = (cov_1vlgqypoqo().s[43]++, (0, _format.default)(new Date(year, month), 'YYYY-MM'));
    var section = (cov_1vlgqypoqo().s[44]++, sectionByMonth[monthName]);
    var cluster = (cov_1vlgqypoqo().s[45]++, section.clusters.find(function (cl) {
      cov_1vlgqypoqo().f[11]++;
      cov_1vlgqypoqo().s[46]++;
      return cl.name === (0, _format.default)(new Date(year, month, day), 'YYYY-MM-DD');
    }));
    var newCluster;
    cov_1vlgqypoqo().s[47]++;
    if ((cov_1vlgqypoqo().b[12][0]++, data) && ((cov_1vlgqypoqo().b[12][1]++, data.occurrences) || (cov_1vlgqypoqo().b[12][2]++, data.tourOccurrences))) {
      cov_1vlgqypoqo().b[11][0]++;
      var _ref7 = (cov_1vlgqypoqo().s[48]++, data),
        occurrences = _ref7.occurrences,
        tourOccurrences = _ref7.tourOccurrences,
        products = _ref7.products,
        tours = _ref7.tours;
      var _ref8 = (cov_1vlgqypoqo().s[49]++, config),
        withTourOnly = _ref8.withTourOnly;
      var firstOccur = (cov_1vlgqypoqo().s[50]++, withTourOnly ? (cov_1vlgqypoqo().b[13][0]++, this.getFirstOccur(tourOccurrences)) : (cov_1vlgqypoqo().b[13][1]++, this.getFirstOccur(occurrences)));
      cov_1vlgqypoqo().s[51]++;
      newCluster = _section.ClusterModel.buildCluster(cluster.rawName, firstOccur, withTourOnly ? (cov_1vlgqypoqo().b[14][0]++, tours.map(function (p) {
        cov_1vlgqypoqo().f[12]++;
        cov_1vlgqypoqo().s[52]++;
        return _this.enhancedProductWithDateParameter(p, new Date(year, month, day));
      })) : (cov_1vlgqypoqo().b[14][1]++, products), config);
    } else {
      cov_1vlgqypoqo().b[11][1]++;
      cov_1vlgqypoqo().s[53]++;
      newCluster = (0, _assign.default)({}, cluster, {
        LOADING: true
      });
    }
    var newSectionByMonth = (cov_1vlgqypoqo().s[54]++, _objectSpread({}, sectionByMonth));
    // generate the section with adapted cluster
    cov_1vlgqypoqo().s[55]++;
    newSectionByMonth[monthName] = (0, _assign.default)({}, section, {
      clusters: section.clusters.map(
      // generate a new array with loading on the day
      function (cl) {
        cov_1vlgqypoqo().f[13]++;
        cov_1vlgqypoqo().s[56]++;
        return cl === cluster ? (cov_1vlgqypoqo().b[15][0]++, newCluster) : (cov_1vlgqypoqo().b[15][1]++, cl);
      })
    });
    cov_1vlgqypoqo().s[57]++;
    return newSectionByMonth;
  },
  hasData: function hasData(calendar) {
    cov_1vlgqypoqo().f[14]++;
    cov_1vlgqypoqo().s[58]++;
    return calendar.sectionByMonth;
  },
  hasMonths: function hasMonths(calendar) {
    cov_1vlgqypoqo().f[15]++;
    cov_1vlgqypoqo().s[59]++;
    return calendar.months;
  },
  /**
   * Function used to get the month section inside a calendar
   * @param {calendarType} calendar, the calendar that contains the section
   * @param {string} month, string representation of the month YYYY-MM
   */
  getMonthSection: function getMonthSection(calendar, month) {
    cov_1vlgqypoqo().f[16]++;
    cov_1vlgqypoqo().s[60]++;
    return (cov_1vlgqypoqo().b[16][0]++, calendar) && (cov_1vlgqypoqo().b[16][1]++, calendar.sectionByMonth) && (cov_1vlgqypoqo().b[16][2]++, calendar.sectionByMonth[month]);
  },
  /**
   * Function used to get the month section inside a calendar
   * @param {calendarType} calendar, the calendar that contains the section
   * @param {*} monthDate, any value that can be transformed in a date using new Date()
   */
  getMonthSectionFromDate: function getMonthSectionFromDate(calendar, monthDate) {
    cov_1vlgqypoqo().f[17]++;
    cov_1vlgqypoqo().s[61]++;
    return CalendarModel.getMonthSection(calendar, (0, _format.default)(new Date(monthDate), 'YYYY-MM'));
  },
  // enhanced product with date query param for better ux in tour/product selection page
  enhancedProductWithDateParameter: function enhancedProductWithDateParameter(product, date) {
    cov_1vlgqypoqo().f[18]++;
    cov_1vlgqypoqo().s[62]++;
    return !date ? (cov_1vlgqypoqo().b[17][0]++, product) : (cov_1vlgqypoqo().b[17][1]++, _product.ProductModel.getCustomAction(product, "&date=".concat((0, _format.default)(date, "DD.MM.YYYY"))));
  }
});
var _default = exports.default = CalendarModel;